export type Language = 'tr' | 'en';

export const LANGUAGE_STORAGE_KEY = 'englishbylevels:language';

export const isLanguage = (value: unknown): value is Language => {
  return value === 'tr' || value === 'en';
};
